import { useDispatch } from "react-redux";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProfile } from "../../../../store/actions/profile.action";
import DynamicFileUploadModal from "../../../../components/modals/DynamicFileUploadModal";
import {
  DynamicFileUploadOption,
  InputType,
} from "../../../../utils/helpers/constants";
import {
  toTitleCase,
  formatAddress,
} from "../../../../utils/helpers/logicHelper";
import moment from "moment";
import Blank from "../../../../assets/images/jpg/blank.jpg";
import EditVehicleOwnerProfileModal from "../../../../components/modals/EditVehicleOwnerProfileModal";
// import { ActionType } from "../../../../utils/helpers/constants";

const TierInfoAlert = ({
  onChange,
  title = "",
  subtitle = "",
  className,
  style = {},
  list = [],
  listheading = "",
}) => (
  <>
    <div
      id="alert-additional-content-5"
      class={`alert alert-secondary border d-flex flex-column ${className ?? ""}`}
      style={style}
      role="alert"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <svg
            class="me-2 flex-shrink-0"
            width="16"
            height="16"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>

          <span class="visually-hidden">Info</span>
          <h5 class="mb-0 fw-medium">{title}</h5>
        </div>

        {/* <button type="button"
            onClick={() => onChange && onChange()}
            class="btn-close ms-auto"
            // data-bs-dismiss="alert"
            // aria-label="Close"
            ></button> */}
      </div>

      <div class="mt-2">{subtitle}</div>
      <div className="mt-2 mb-4">
        <div>{listheading}</div>
        <ol>
          {list.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ol>
      </div>
    </div>
  </>
);

const tierDetails = {
  "TIER-1": {
    title: "Tier 1 Verification Completed",
    subtitle:
      "You have succesfully registered your vehile owner profile. The default tier is Tier 1. To move to Tier 2, follow the instructions in the next section.",
    listheading: " The features are available to you under Tier 1 include:",
    list: ["Quick Pay", "Trip Logging", "Quick Topup"],
  },

  "TIER-2": {
    title: "Tier 2 Verification Completed",
    subtitle:
      "Great progress! By uploading your tier 2 requirements.To move to Tier 3, follow the instructions in the next section.",
    listheading: " The features are available to you under Tier 2 include:",
    list: [],
  },

  "TIER-3": {
    title: "Tier 3 Verification Completed",
    subtitle:
      "You’ve completed all verification steps. Your profile is fully verified, giving you priority access to high-value business trips, trusted enterprise clients, and maximum earning opportunities on the platform.",
    listheading: " The features are available to you under Tier 3 include:",
    list: ["fuel services"],
  },
  DEFAULT: {
    title: "Verification Status",
    subtitle:
      "Your verification status is currently unavailable. Please complete the required verification steps to start accessing jobs and platform benefits.",
    list: [],
  },
};

const verificationDescription = {
  NIN_SCAN:
    "Submitting your National Identification Number (NIN) scan verifies your identity and moves your account to Tier 2, allowing you access tier 2 features",
 
  NIN:
    "Submitting your National Identification Number (NIN) verifies your identity and moves your account to Tier 2, allowing you access tier 2 features",

  CAC_SCAN:
    "Uploading your CAC registration document verifies your business and upgrades your account to Tier 3, unlocking access to teir 3 features ",

  UTILITY_UPLOAD:
    "Providing a valid proof of address completes your verification and moves your account to Tier 2. Allowing you access tier 2 features",

  DEFAULT:
    "Complete the required verification steps to activate your vehicle profile and start accessing job requests on the platform.",
};

const tier_requirements_list = {
  2: ["nin", "nin_scan","house_address", "utility_upload"],
  3: ["cac_number", "cac_scan"],
};

const merged_tier_requirements_list = Object.values(tier_requirements_list).flat();

const convertCurrentTierToNumber = (tier) => {
  if (tier.toUpperCase() === "TIER-1") return 1;
  if (tier.toUpperCase() === "TIER-2") return 2;
  if (tier.toUpperCase() === "TIER-3") return 3;
  return 0;
};


const sortTiers = (currentTierRequirements) => (a, b) => {
  const indexA = currentTierRequirements.indexOf(a.key);
  const indexB = currentTierRequirements.indexOf(b.key);

  // If both items are in the currentTierRequirements, sort by their index.
  if (indexA > -1 && indexB > -1) {
    return indexA - indexB;
  }
  
  // Optional: Handle items not in currentTierRequirements.
  // The following logic places items *not* in currentTierRequirements at the end of the sorted array.
  // If one item is in the currentTierRequirements and the other isn't, the one in the array comes first.
  if (indexA > -1) return -1;
  if (indexB > -1) return 1;
  
  // If neither is in the currentTierRequirements, maintain their original relative order (or sort alphabetically etc.)
  return 0;   
  }

const Body = ({ profile, dynamicFields , fullProfile }) => {
  //new comment
  const dispatch = useDispatch() , navigate = useNavigate();
  const [vehicleOwnerDocument, setVehicleOwnerDocument] = useState(null);
  const [editVehicleOwnerRender, setEditVehicleOwnerRender] = useState(false);
  const [
    uploadVehicleOwnerDocumentRender,
    setUploadVehicleOwnerDocumentRender,
  ] = useState(false);
  const [toggleExplanationModal, setToggleExplanationModal] = useState(false);
  const [selectedUpdateInput, setSelectedUpdateInput] = useState("");
  const createBusinessProfile = (action) => navigate('/onboard-business?direction=goback', { state: { actionType: action, business: {} } });

  const maximumTier = 3;
  const documentUpload = dynamicFields.filter(
    (each) =>
      each.type === "file" &&
      !each["hidden_field"] &&
      (each.key === "nin_scan" ||
        each.key === "cac_scan" ||
        each.key === "utility_upload"),
  );

  const nextTierRequirements =
    tier_requirements_list[convertCurrentTierToNumber(profile?.tier) + 1] || [];

  const currentTierRequirements =  tier_requirements_list[convertCurrentTierToNumber(profile?.tier)] || [];

  const dynamicFieldsFiltered = dynamicFields.filter((each) =>
    nextTierRequirements.includes(each.key),
  ).sort(sortTiers(nextTierRequirements));

  const dynamicFieldsFilteredForCurrentTier = dynamicFields.filter((each) =>
    currentTierRequirements.includes(each.key),
  ).sort(sortTiers(currentTierRequirements));

  const allDynamicFieldsForCurrentAndNextTier = dynamicFields.filter((each) =>
    merged_tier_requirements_list.includes(each.key)
  ).sort(sortTiers(merged_tier_requirements_list));

  const onSuccessfulUpload = async () => dispatch(getProfile());

  const openUploadVehicleOwnerDocumentRender = (file) => {
    setVehicleOwnerDocument(file);
    setUploadVehicleOwnerDocumentRender(true);
  };

  const changeEditVehicleOwnerProfileRender = () =>
    setEditVehicleOwnerRender(false);
  const changeUploadVehicleOwnerDocumentRender = () =>
    setUploadVehicleOwnerDocumentRender(false);

  const vehicleOwnerDynamicField = [
    {
      key: "nin",
      name: "NIN",
      type: "text",
      label: "Nin",
      unique: true,
      default: false,
      options: [],
      required: false,
      max_length: "11",
      min_length: "11",
      placeholder: "National Identification Number (N.I.N)",
      hidden_field: false,
      verify_object: false,
    },
    {
      key: "cac_number",
      name: "cac_number",
      type: "text",
      label: "Cac Number",
      unique: true,
      default: false,
      options: [],
      required: false,
      max_length: "7",
      min_length: "7",
      placeholder: "enter your business cac number",
      hidden_field: false,
      verify_object: false
    },
    {
      key: "house_address",
      name: "house_address",
      type: "text",
      label: "Enter Your Current Residential Address",
      unique: true,
      default: false,
      options: [],
      required: true,
      max_length: "50",
      min_length: "5",
      placeholder: "e.g 22, Mushin Rd, Mushin, Lagos",
      hidden_field: false,
      verify_object: true,
    },
  ];


  const editVehicleOwnerProfileModal = editVehicleOwnerRender && (
    <EditVehicleOwnerProfileModal
      onchange={changeEditVehicleOwnerProfileRender}
      props={profile}
       dynamicFields={vehicleOwnerDynamicField.filter(
        (item) => item.key === selectedUpdateInput,
      )}
      // dynamicFields={vehicleOwnerDynamicField}
      onSuccessResponse={onSuccessfulUpload}
    />
  );

  const uploadVehicleOwnerDocumentModal = uploadVehicleOwnerDocumentRender && (
    <DynamicFileUploadModal
      onchange={changeUploadVehicleOwnerDocumentRender}
      type={DynamicFileUploadOption.VEHICLE_OWNER}
      props={profile}
      dynamicFields={vehicleOwnerDocument}
      onSuccessResponse={onSuccessfulUpload}
    />
  );

  return (
    <div className="settings-main p-4">
      {uploadVehicleOwnerDocumentModal}
      {editVehicleOwnerProfileModal}
      {/* <div className="d-flex justify-content-end">
        <button
          className="btn primary-btn text-decoration-none mg-r-3 mb-2"
          onClick={() => setEditVehicleOwnerRender(true)}
        >
          Edit Vehicle Owner Profile
        </button>
      </div> */}

      <div className="row mt-4">
        <div className="col-12 mb-3">
          <div className="main-card profile h-100">
            <div className="profile-header p-3">
              <div className="d-flex justify-content-between">
                <div>
                  <p className="fs-20 my-auto">
                    {profile?.["tier"]?.toUpperCase() ?? ""}
                  </p>
                </div>
                <div>
                  <i
                    className={
                      toggleExplanationModal
                        ? "zmdi zmdi-chevron-up fs-3 text-black"
                        : "zmdi zmdi-chevron-down fs-3 text-black"
                    }
                    onClick={() =>
                      setToggleExplanationModal((prevState) => !prevState)
                    }
                  />
                </div>
              </div>
              <div className="mt-2">
                {toggleExplanationModal && (
                  <>
                    <TierInfoAlert
                      title={
                        tierDetails[profile?.["tier"]?.toUpperCase()]?.title ??
                        tierDetails["DEFAULT"]?.title
                      }
                      subtitle={
                        tierDetails[profile?.["tier"]?.toUpperCase()]
                          ?.subtitle ?? tierDetails["DEFAULT"]?.subtitle
                      }
                      list={
                        tierDetails[profile?.["tier"]?.toUpperCase()]?.list ??
                        tierDetails["DEFAULT"]?.list
                      }
                      listheading={
                        tierDetails[profile?.["tier"]?.toUpperCase()]
                          ?.listheading ?? tierDetails["DEFAULT"]?.listheading
                      }
                    />
                  </>
                )}
              </div>
            </div>
            <div className="profile-body p-3">
              <div className="row">
                {/* {dynamicFields &&dynamicFields.map((item) => { */}
                {dynamicFieldsFilteredForCurrentTier && dynamicFieldsFilteredForCurrentTier.map((item) => {
                    const fieldValue = profile?.dynamic_fields?.[item.key];
                    let display = "-";

                    if (item.type === InputType.DATE) {
                      display = moment(fieldValue).isValid()
                        ? moment(fieldValue).format("DD-MMMM-YYYY")
                        : "-";
                    } else if (item.key === "house_address") {
                      display = fieldValue ? formatAddress(fieldValue) : "-";
                    } else if (fieldValue) {
                      display = fieldValue;
                    }
                    return (
                      <Fragment key={item.key}>
                        {item.key in profile["dynamic_fields"] &&
                           (
                            <div className="col-md-6 mb-3">
                              <p className="mb-0 profile-info-name text-truncate">
                                {toTitleCase(item.key)}
                              </p>
                             { item.type === InputType.FILE ? (<>
                               <a href={display}>{item.key} upload</a>
                             </>): <span
                                className="profile-info-deet text-truncate d-block w-100"
                                style={{ maxWidth: "100%" }}
                              >
                                {display}
                              </span>}
                            </div>
                          )}
                      </Fragment>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {convertCurrentTierToNumber(profile?.tier) !== maximumTier  && <h1 className="mt-4">Next Steps</h1>}

      { convertCurrentTierToNumber(profile?.tier) !==  maximumTier && documentUpload && documentUpload.length > 0 && (
        <div className="main-card profile mt-3">
          <div className="profile-header p-3">
            <h5>
              To move to Tier {convertCurrentTierToNumber(profile?.tier) + 1}, provide the supporting documents below.
              Features available under Tier {convertCurrentTierToNumber(profile?.tier) + 1} include: document renewals
            </h5>
          </div>
          <div className="container-fluid px-0">
            <div className="row p-3 items-stretch">
              {dynamicFieldsFiltered.map((item) => (
                // {documentUpload.map((item) => (
                <div key={item.key} className="col-xl-6 mb-3">
                  <div className="profile-vehicle-image overflow-hidden h-auto">
                    {/* <div className="profile-vehicle-image overflow-hidden h-100"> */}
                    <div className="card-body bg-primary py-2 mb-0">
                      <div className="d-flex justify-content-between">
                        <span className="card-text">
                          {toTitleCase(item.key)}
                        </span>
                        <i
                          className="zmdi zmdi-plus-circle fs-3 text-white"
                          onClick={() => {
                            if (item.type === "file") {
                              openUploadVehicleOwnerDocumentRender(item);
                            }
                            if (item.type === "text"){
                              setSelectedUpdateInput(item.key);
                              setEditVehicleOwnerRender(true);
                            }
                          }}
                        />
                      </div>
                    </div>

                    {profile["dynamic_fields"][item.key] ? (
                     <>{item.type === "file" ?(<img
                        src={profile["dynamic_fields"][item.key] ?? Blank}
                        alt={toTitleCase(item.key)}
                        className="mx-auto d-block w-100 "
                      />): (<div style={{ height: "184px" , backgroundColor: "#e2e3e5" }} className="w-100 h-90 pt-3 rounded-bottom-1 px-3 fw-bold">{profile["dynamic_fields"][item.key] }</div>)}</>
                    ) : (
                      <>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ height: "200px" }}
                        >
                          <TierInfoAlert
                            title={"Add Information"}
                            style={{ height: "92%" }}
                            subtitle={
                              verificationDescription[item.key.toUpperCase()] ??
                              verificationDescription.DEFAULT
                            }
                            className="w-100 h-90 rounded-top-0"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
               {
                    // ((!profile['is_business'] && !profile['is_driver'] && !profile['is_vehicle_owner'] && !profile['is_account_manager'])
                    //   || (profile['is_business'] && domState.type === DomStateType.BUSINESS)) 
                    (convertCurrentTierToNumber(profile?.tier) === 2)
                      &&
                      <div className="order-md-1 order-2 btns-sm mb-4 mt-3 mt-md-0 mx-md-1 col-xl-6 mb-3">
                        <button disabled={fullProfile?.userData?.is_business} className="btn primary-btn  mg-r-5 mb-3 w-100" onClick={() => { createBusinessProfile("CREATE"); }}>{fullProfile?.userData?.is_business ? "Business already onboarded" : "Onboard business"}</button>
                        {/* {domState.type === DomStateType.BUSINESS &&
                          <button className="btn secondary-btn w-100" onClick={() => { createBusinessProfile("UPDATE") }}>Update business</button>
                        } */}
                      </div>
                    }
            </div>

          </div>
        </div>
      )}


      {convertCurrentTierToNumber(profile?.tier) === maximumTier  && <h1 className="mt-4">Supporting Documents</h1>}

      { convertCurrentTierToNumber(profile?.tier) ===  maximumTier && documentUpload && documentUpload.length > 0 && (
        <div className="main-card profile mt-3">
          <div className="profile-header p-3">
            <h5>
              View and edit supporting documents across tiers. Removing a supporting document may affect your tier level.
            </h5>
          </div>
          <div className="container-fluid px-0">
            <div className="row p-3 items-stretch">
              {allDynamicFieldsForCurrentAndNextTier.map((item) => (
                // {documentUpload.map((item) => (
                <div key={item.key} className="col-xl-6 mb-3">
                  <div className="profile-vehicle-image overflow-hidden h-auto">
                    {/* <div className="profile-vehicle-image overflow-hidden h-100"> */}
                    <div className="card-body bg-primary py-2 mb-0">
                      <div className="d-flex justify-content-between">
                        <span className="card-text">
                          {toTitleCase(item.key)}
                        </span>
                        <i
                          className="zmdi zmdi-plus-circle fs-3 text-white"
                          onClick={() => {
                            if (item.type === "file") {
                              openUploadVehicleOwnerDocumentRender(item);
                            }
                            if (item.type === "text"){
                              setSelectedUpdateInput(item.key);
                              setEditVehicleOwnerRender(true);
                            }
                          }}
                        />
                      </div>
                    </div>

                    {profile["dynamic_fields"][item.key] ? (
                     <>{item.type === "file" ?(<img
                        src={profile["dynamic_fields"][item.key] ?? Blank}
                        alt={toTitleCase(item.key)}
                        className="mx-auto d-block w-100 "
                      />): (<div style={{ height: "184px" , backgroundColor: "#e2e3e5" }} className="w-100 h-90 pt-3 rounded-bottom-1 px-3 fw-bold">{profile["dynamic_fields"][item.key] }</div>)}</>
                    ) : (
                      <>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ height: "200px" }}
                        >
                          <TierInfoAlert
                            title={"Add Information"}
                            style={{ height: "92%" }}
                            subtitle={
                              verificationDescription[item.key.toUpperCase()] ??
                              verificationDescription.DEFAULT
                            }
                            className="w-100 h-90 rounded-top-0"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ))}
               {
                    // ((!profile['is_business'] && !profile['is_driver'] && !profile['is_vehicle_owner'] && !profile['is_account_manager'])
                    //   || (profile['is_business'] && domState.type === DomStateType.BUSINESS)) 
                    (convertCurrentTierToNumber(profile?.tier) === 2)
                      &&
                      <div className="order-md-1 order-2 btns-sm mb-4 mt-3 mt-md-0 mx-md-1 col-xl-6 mb-3">
                        <button disabled={fullProfile?.userData?.is_business} className="btn primary-btn  mg-r-5 mb-3 w-100" onClick={() => { createBusinessProfile("CREATE"); }}>{fullProfile?.userData?.is_business ? "Business already onboarded" : "Onboard business"}</button>
                        {/* {domState.type === DomStateType.BUSINESS &&
                          <button className="btn secondary-btn w-100" onClick={() => { createBusinessProfile("UPDATE") }}>Update business</button>
                        } */}
                      </div>
                    }
            </div>

          </div>
        </div>
      )}



    </div>
  );
};

export default Body;
